import React from 'react';

import { Icon } from '@rbilabs/components-library';

import { IButtonProps } from '@rbi-ctg/frontend';
import { CustomEventNames, EventTypes, useMParticleContext } from 'state/mParticle';

import { BtnArrow } from './btn-arrow';
import { StyledButton } from './styled-wrapper-button';

export interface IWrapperButtonProps extends IButtonProps {
  eventName?: CustomEventNames;
  eventType?: EventTypes;
}

const WrapperButton: React.FC<IWrapperButtonProps> = ({
  className,
  children,
  disabled,
  onClick,
  'data-testid': dataQaId,
  eventName,
  eventType,
}) => {
  const mParticle = useMParticleContext();
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    mParticle.logEvent(
      eventName || CustomEventNames.BUTTON_CLICK,
      eventType || EventTypes.Navigation
    );

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <StyledButton
      className={className}
      data-testid={dataQaId}
      onClick={handleClick}
      disabled={disabled}
    >
      {children}
      <BtnArrow aria-hidden>
        <Icon icon="next" color="icon-default" width="16px" aria-hidden />
      </BtnArrow>
    </StyledButton>
  );
};

export default WrapperButton;
